<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.mobile"
    max-width="95%"
    content-class="report-dialog"
    scrollable
  >
    <!-- eslint-disable-next-line vue/no-unused-vars -->
    <template v-slot:activator="on">
      <slot name="open" :open="open"></slot>
    </template>
    <v-card :class="{ 'rounded-0': $vuetify.breakpoint.mobile }">
      <v-toolbar color="primary" dark elevation="1" dense>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="mt-4">
        <v-container>
          <div class="content">
            <div class="tab-container">
              <PDFViewer :url="pdfURL"></PDFViewer>
            </div>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import Api from '@/resources/NajaSocialApi'
import PDFViewer from '@/components/PDFViewer'

export default {
  name: 'PDFDialog',
  components: { PDFViewer },
  props: {
    title: {
      type: String,
      default: '',
    },
    url: {
      type: String,
    },
  },

  data() {
    return {
      dialog: false,
      loading: false,
      pdfURL: null,
    }
  },

  methods: {
    open(url) {
      this.pdfURL = url
      this.dialog = true
    },
  },
}
</script>
<style>
.report-dialog {
  height: 100%;
}
</style>
<style lang="css" scoped>
.v-toolbar {
  flex: unset;
}

.v-card .container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.content {
  flex-grow: 1;
  overflow: hidden;
  height: 100%;
}

.tab-container,
.file-container {
  height: 100%;
}
.ui.fullscreen.modal {
  min-height: 95%;
}

.download h2 {
  margin-top: 20px;
  color: var(--button-primary-bg-color) !important;
}

.ui.mini.button {
  margin-bottom: 5px;
}

span.label {
  padding-right: 10px;
  padding-right: 20px;
}

.tab-container {
  text-align: center;
}

.tab-container img {
  max-width: 100%;
}

/* iframe {
  width: 100%;
  border: none;
  min-height: 600px;
} */

.ui.negative.message {
  max-width: 300px;
  margin: 0 auto;
  margin-top: 100px;
  text-align: center;
}

.report-contrainer {
  min-height: 200px;
  overflow: auto;
}

.mini.button {
  width: 120px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
